import { RequestStatus } from 'types/common';
import { Type } from './action-types';
import { stateFactory } from './factories';
import { WizardExportAction, WizardExportState } from './types';

const defaultState = stateFactory();

function reducer(
  state: WizardExportState = defaultState,
  action: WizardExportAction,
): WizardExportState {
  switch (action.type) {
    case Type.CREATION_REQUEST: {
      return defaultState.set('status', RequestStatus.REQUEST);
    }
    case Type.CREATION_SUCCESS: {
      const { creationId } = action.payload;
      return state
        .set('creationId', creationId)
        .set('status', RequestStatus.SUCCESS);
    }

    case Type.CREATION_FAILURE: {
      return state.set('status', RequestStatus.FAILURE);
    }

    case Type.CREATION_CLEAR:
      return defaultState;

    case Type.CREATION_STATUS_POLL_REQUEST:
      return state.set('pollStatus', RequestStatus.REQUEST);

    case Type.CREATION_STATUS_POLL_SUCCESS:
      return state.set('pollStatus', RequestStatus.SUCCESS);

    case Type.CREATION_STATUS_POLL_FAILURE:
      return state.set('pollStatus', RequestStatus.FAILURE);

    case Type.CREATE_CREATION_ASSET_REQUEST: {
      return defaultState.set(
        'createCreationAssetStatus',
        RequestStatus.REQUEST,
      );
    }

    case Type.CREATE_CREATION_ASSET_SUCCESS: {
      const {
        uploadedRecordingId,
        captionSourceEddyProjectCuid,
      } = action.payload;

      return state
        .set('uploadedRecordingId', uploadedRecordingId)
        .set('captionSourceEddyProjectCuid', captionSourceEddyProjectCuid)
        .set('createCreationAssetStatus', RequestStatus.SUCCESS);
    }

    case Type.CREATE_CREATION_ASSET_FAILURE: {
      return state.set('createCreationAssetStatus', RequestStatus.FAILURE);
    }

    case Type.CREATE_CREATION_ASSET_CLEAR:
      return state
        .set('uploadedRecordingId', undefined)
        .set('captionSourceEddyProjectCuid', undefined)
        .set('createCreationAssetStatus', undefined);

    default:
      return state;
  }
}

export default reducer;
